"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("models").service("DepasService", ["ApiService", "DamagesService", "moment", function (ApiService, DamagesService, moment) {
  var that = this;

  var params = {
    name: "depas",
    attributesForCache: ["status", "shortId", "emailToUse", "phoneToUse"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    },
    defaultOrder: { creationDate: -1 }
  };

  angular.extend(that, ApiService.getModelBis(params));

  that.getLatestInterviewDocument = function (depa) {
    var findLatest = function findLatest(docs, names) {
      if (!Array.isArray(docs)) {
        return null;
      }
      for (var index = docs.length - 1; index >= 0; index -= 1) {
        var doc = docs[index];
        if (doc && doc.url && names.includes(doc.what && doc.what.name)) {
          return doc;
        }
      }
      return null;
    };

    return findLatest(depa && depa.managerAct && depa.managerAct.docs, ["Fiche Entretien Signée", "Fiche Entretien"]) || findLatest(depa && depa.docs, ["Fiche Entretien"]);
  };

  that.loadForPeriod = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
      var range, whereDepa, depasPromise, data, depas, depaIds, damages, index, batch;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              range = {
                $gte: moment(options.from).startOf("day").toDate(),
                $lt: moment(options.to).startOf("day").add(1, "day").toDate()
              };
              whereDepa = { status: { $ne: "Fermé" } };

              whereDepa[options.withDepaSlot ? "slot.start" : "creationDate"] = range;

              depasPromise = that.load(options.depaFields, false, null, whereDepa);

              if (options.withDepaSlot) {
                _context.next = 9;
                break;
              }

              _context.next = 7;
              return Promise.all([DamagesService.load(options.damageFields, false, null, {
                dateDamage: range
              }), depasPromise]);

            case 7:
              data = _context.sent;
              return _context.abrupt("return", { damages: data[0], depas: data[1] });

            case 9:
              _context.next = 11;
              return depasPromise;

            case 11:
              depas = _context.sent;
              depaIds = depas.map(function (depa) {
                return "$" + depa._id;
              });
              damages = [];
              index = 0;

            case 15:
              if (!(index < depaIds.length)) {
                _context.next = 23;
                break;
              }

              _context.next = 18;
              return DamagesService.load(options.damageFields, false, null, { depaId: { $in: depaIds.slice(index, index + 500) } });

            case 18:
              batch = _context.sent;

              damages.push.apply(damages, _toConsumableArray(batch));

            case 20:
              index += 500;
              _context.next = 15;
              break;

            case 23:
              return _context.abrupt("return", { damages: damages, depas: depas });

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}]);